import { registerRendererGroup, registerToolRendererGroup, ShapeFunctions } from "../../util/shapeCategorySingleton";
import { calculateImageSnapPoints, createImage, createImageRubber, globalImage, imageBoundingboxCalculation, lineIntersectWithRect, transformImageToInternalShape } from "./Symbol";
import { createImageBase } from "./SymbolBase";
import createDefaultPropertyPalette from "./SymbolDefaultProperyPalette";
import createPropertyPalette from "./SymbolProperyPalette";

const imageFunctions: ShapeFunctions = {
  shapeRendererGroup: {
    shapeRender: createImage,
    rubberlineRender: createImageRubber,
    baseShapeRenderer: createImageBase,
  },
  shapeTransformerGroup: {
    snapPointCalculator: calculateImageSnapPoints,
    rectangleIntersectCheck: (s: GeometricShape, r: RectSel) => {
      return lineIntersectWithRect(s, r);
    },
    globalShapeTransformer: globalImage,
    transformToInternalShape: transformImageToInternalShape,
    calculateWidthHeight: imageBoundingboxCalculation,
  },
  UIElementRender: {
    propertyPaletteRenderer: createPropertyPalette,
    defaultPropertyPaletteRenderer: createDefaultPropertyPalette,
  },
}

registerRendererGroup("symbol", imageFunctions);
registerToolRendererGroup("symbol", { toolRender: createImageRubber });